<template>
  <div class="container">
    <Menu />

    <h1 class="title is-5 ch-tieu-de">{{ lang('Cấu hình Site') }}</h1>

    <SettingsUpload />
    <SettingsSecurity />
  </div>
</template>

<script>
import Menu from './partials/Menu'
import SettingsUpload from './partials/SettingsUpload'
import SettingsSecurity from './partials/SettingsSecurity'

export default {
  name: 'CauHinh',
  components: { Menu, SettingsUpload, SettingsSecurity },
}
</script>

<style scoped>
.ch-tieu-de {
  margin: 50px 0 0 0;
}
</style>
